export default {
  login: 'loginAction',
  getProperties: 'getProperties',
  fetchProperties: 'fetchProperties',
  tfaLogin: 'tfaLogin',
  fetchActiveLanguages: 'fetchActiveLanguages'
}
